import { Copy01 } from "@untitledui/icons";
import { Tooltip, TooltipTrigger } from "@/components/base/tooltip/tooltip";
import { EmptyValue } from "@/components/common/EmptyValue";
import { useClipboard } from "@/hooks/use-clipboard";
import { formatId } from "@/utils/format-id";

const CopyableId = ({
	value,
	detailText = false,
}: {
	value: string;
	detailText?: boolean;
}) => {
	const { copy, copied } = useClipboard();
	const textClass = detailText
		? "font-bold text-gray-900 font-mono"
		: "text-sm font-medium font-mono";

	return (
		<div className="flex items-center gap-2">
			{value ? (
				<div className="inline-flex min-w-0 max-w-full">
					<Tooltip title={value} placement="top">
						<TooltipTrigger className="inline-flex min-w-0 max-w-[150px]">
							<p className={textClass}>{formatId(value)}</p>
						</TooltipTrigger>
					</Tooltip>
				</div>
			) : (
				<EmptyValue />
			)}
			<Tooltip
				title="Copied!"
				placement="top"
				isOpen={copied === "userId" ? true : undefined}
				isDisabled={copied !== "userId"}
			>
				<TooltipTrigger>
					<button
						type="button"
						aria-label={copied === "userId" ? "Copied!" : "Copy User ID"}
						onClick={() => {
							copy(value || "", "userId");
						}}
						className={`rounded-md border p-1 transition-all duration-200 cursor-pointer ${
							copied === "userId"
								? "border-success-800"
								: "border-transparent hover:border-gray-300"
						}`}
					>
						<Copy01
							size={16}
							className={`transition-colors duration-200 ${
								copied === "userId" ? "text-success-800" : "text-gray-400"
							}`}
						/>
					</button>
				</TooltipTrigger>
			</Tooltip>
		</div>
	);
};

export default CopyableId;
